import React from 'react';
import { GlobeIcon, DatabaseIcon, SmartphoneIcon, ZapIcon, SaveIcon } from 'lucide-react';
import { useApp } from '../context/AppContext';
export function Settings() {
  const {
    state,
    dispatch
  } = useApp();
  const {
    language
  } = state;
  return <div className="p-4 lg:p-6 max-w-4xl mx-auto space-y-6" data-id="element-1137">
      {/* Header */}
      <div data-id="element-1138">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1139">
          {language === 'en' ? 'Settings' : 'সেটিংস'}
        </h1>
        <p className="text-gray-600 mt-1" data-id="element-1140">
          {language === 'en' ? 'System configuration and preferences' : 'সিস্টেম কনফিগারেশন এবং পছন্দসমূহ'}
        </p>
      </div>

      <div className="space-y-6" data-id="element-1141">
        {/* Language */}
        <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-1142">
          <div className="flex items-start gap-4" data-id="element-1143">
            <div className="p-2 bg-blue-100 rounded-lg" data-id="element-1144">
              <GlobeIcon className="w-6 h-6 text-blue-600" data-id="element-1145" />
            </div>
            <div className="flex-1" data-id="element-1146">
              <h3 className="font-semibold text-gray-900" data-id="element-1147">Language / ভাষা</h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1148">
                Select your preferred interface language
              </p>

              <div className="mt-4 flex gap-4" data-id="element-1149">
                <button onClick={() => dispatch({
                type: 'SET_LANGUAGE',
                payload: 'en'
              })} className={`flex-1 py-3 px-4 rounded-lg border-2 text-sm font-medium transition-all ${language === 'en' ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-gray-200 hover:border-gray-300 text-gray-600'}`} data-id="element-1150">
                  English
                </button>
                <button onClick={() => dispatch({
                type: 'SET_LANGUAGE',
                payload: 'bn'
              })} className={`flex-1 py-3 px-4 rounded-lg border-2 text-sm font-medium transition-all ${language === 'bn' ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-gray-200 hover:border-gray-300 text-gray-600'}`} data-id="element-1151">
                  বাংলা
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Backup */}
        <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-1152">
          <div className="flex items-start gap-4" data-id="element-1153">
            <div className="p-2 bg-green-100 rounded-lg" data-id="element-1154">
              <DatabaseIcon className="w-6 h-6 text-green-600" data-id="element-1155" />
            </div>
            <div className="flex-1" data-id="element-1156">
              <div className="flex items-center justify-between" data-id="element-1157">
                <div data-id="element-1158">
                  <h3 className="font-semibold text-gray-900" data-id="element-1159">
                    Backup & Recovery
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1160">
                    Automated daily backups are enabled
                  </p>
                </div>
                <div className="relative inline-flex h-6 w-11 items-center rounded-full bg-blue-600" data-id="element-1161">
                  <span className="translate-x-6 inline-block h-4 w-4 transform rounded-full bg-white transition" data-id="element-1162" />
                </div>
              </div>
              <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-1163">
                <div className="flex items-center justify-between text-sm" data-id="element-1164">
                  <span className="text-gray-600" data-id="element-1165">Last backup completed</span>
                  <span className="font-medium text-gray-900" data-id="element-1166">
                    2026-02-24 02:00 AM
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Performance */}
        <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-1167">
          <div className="flex items-start gap-4" data-id="element-1168">
            <div className="p-2 bg-amber-100 rounded-lg" data-id="element-1169">
              <ZapIcon className="w-6 h-6 text-amber-600" data-id="element-1170" />
            </div>
            <div className="flex-1" data-id="element-1171">
              <h3 className="font-semibold text-gray-900" data-id="element-1172">
                System Performance
              </h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1173">
                Target response time metrics
              </p>

              <div className="mt-4 grid grid-cols-2 gap-4" data-id="element-1174">
                <div className="p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-1175">
                  <p className="text-xs text-gray-500 uppercase" data-id="element-1176">API Latency</p>
                  <p className="text-lg font-bold text-gray-900 mt-1" data-id="element-1177">124ms</p>
                  <p className="text-xs text-green-600 mt-1" data-id="element-1178">
                    Target: &lt; 300ms
                  </p>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-1179">
                  <p className="text-xs text-gray-500 uppercase" data-id="element-1180">Uptime</p>
                  <p className="text-lg font-bold text-gray-900 mt-1" data-id="element-1181">99.99%</p>
                  <p className="text-xs text-green-600 mt-1" data-id="element-1182">
                    Target: &gt; 99.9%
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Optimization */}
        <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-1183">
          <div className="flex items-start gap-4" data-id="element-1184">
            <div className="p-2 bg-purple-100 rounded-lg" data-id="element-1185">
              <SmartphoneIcon className="w-6 h-6 text-purple-600" data-id="element-1186" />
            </div>
            <div className="flex-1" data-id="element-1187">
              <h3 className="font-semibold text-gray-900" data-id="element-1188">
                Mobile Optimization
              </h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1189">
                The interface is fully responsive and optimized for mobile
                devices. Field officers can access records on-site using tablets
                or smartphones.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-1190">
          <button className="flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-1191">
            <SaveIcon className="w-5 h-5" data-id="element-1192" />
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}